import React from "react";
import "./ProjectLinks.css";
import { Icon } from "@iconify/react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function ProjectLinks(props) {
  function openRepoinNewTab(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  // console.log(props);
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons-languages">
          {props.logos.map((logo) => {
            return (
              <OverlayTrigger
                key={logo.name}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    <strong>{logo.name}</strong>
                  </Tooltip>
                }
              >
                <li
                  className="software-skill-inline-languages"
                  name={logo.skillName}
                  onClick={() => openRepoinNewTab(logo.url)}
                >
                  <Icon
                    icon={logo.iconifyClass.replace("logos-", "logos:")}
                    style={{
                      fontSize: "1.8rem",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    className="project-link-icon"
                  />
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default ProjectLinks;
